import PropTypes from 'prop-types';
import React from "react";
import buildUrl from "build-url-ts";
import _ from "lodash";

import isEqual from "is-equal";
import cx from "classnames";
import { Row, Col } from "react-bootstrap";

import {
  ToolBar,
  ToolBarGroup,
} from "src/legacy/components/ToolBar/ToolBar.jsx";
import { ToolBarButtonItem } from "src/legacy/components/ToolBar/ToolBarButtonItem.jsx";

import SearchResultView from "./SearchResultView";
import AssetSearchResultContainer from "./asset/AssetSearchResultContainer";
import CustomFieldSearchViewContainer from "./customField/CustomFieldSearchViewContainer";

import styles from "./styles.module.scss";

import { localizedStrings } from 'src/localization';
import userRoleService from 'src/utils/userRoles.service';
import SeekLandingPage from './seekSearchLandingPage'
import SeekResponse from './seekResponse/index.jsx';
import EmptyContentView from './EmptyMessageNewUi/EmptyContentView.jsx'

class DetailedSearchView extends React.Component {
  static childContextTypes = {
    recordAssetClicked: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      query: "",
      isSearch: false,
      selectedTags: [],
      selectedCustomFields: [],
      searchedQuery: "",
    };

    this.primaryBackground = null;
    this._onQueryChange = this._onQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._performSearch = this._performSearch.bind(this);
    this.loadMoreResults = this.loadMoreResults.bind(this);
    this.onSelectTagClicked = this.onSelectTagClicked.bind(this);
    this.resetTagFilters = this.resetTagFilters.bind(this);
    this._handleFieldsFilterChange = this._handleFieldsFilterChange.bind(this);
    this.recordAssetClicked = this.recordAssetClicked.bind(this);
    this.handleInitialSearch = this.handleInitialSearch.bind(this);

    this.containerRef = React.createRef(null);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;
  }

  getChildContext() {
    return {
      recordAssetClicked: this.recordAssetClicked,
    };
  }

  onFilterChange(filter) {

    this.setState({
      filter: filter,
    });

    this.handleViewMoreClick(filter);
  }

  handleViewMoreClick(field) {
    var url = `/search/${field}`;
    if (field === "all") {
      url = `/search`;
    }

    if (this.state.query != "") {
      url = `${url}?query=${this.state.query}`;
    }
    this.setState({
    searchedQuery: this.state.query
  });
    this.props.navigate(url);
  }

  _onQueryChange(e) {
    this.setState({
      query: e.target.value,
      selectedTags: [],
    });
  }

  _handleSearch(e) {


    if (e) {
      e.preventDefault();
    }

    var query = this.state.query;
    this.setState(
      {
        query: query,
        selectedTags: [],
      },
      () => {
        this._updateSearchUrl(this.props);
      }
    );
  }

  _handleFieldsFilterChange(fields) {
    this.setState(
      {
        selectedCustomFields: fields,
        selectedTags: [],
      },
      () => {
        this._updateSearchUrl(this.props);
      }
    );
  }

  _updateSearchUrl(props) {
    var query = this.state.query;
    var tags = this.state.selectedTags;
    var selectedCustomFields = this.state.selectedCustomFields || [];

    var entityType = props.entityType;
    var url = `/search/${entityType}`;
    var tagsValue = null;

    var queryParams = {};

    this.setState({
      filter: entityType,
    });

    if (query != "" && typeof query !== "undefined") {
      queryParams["query"] = query;
    }

    var fieldQuery =
      this.convertFieldsFilterToQueryParams(selectedCustomFields);
    if (fieldQuery && props.entityType == "assets") {
      queryParams["fields"] = fieldQuery;
    }

    if (tags.length > 0) {
      tagsValue = tags.join(",");
      queryParams["tags"] = tagsValue;
    }

    url = buildUrl(url, {
      queryParams: queryParams,
    });

    this.props.navigate(url);
    // browserHistory.replace(url);
  }

  _performSearch(props) {


    var query = _.get(this.state, 'query');
    var tags = this.state.selectedTags;
    var selectedCustomFields = this.state.selectedCustomFields || [];
    var entityType = props.entityType;
    var url = `/search/${entityType}`;
    var tagsValue = null;
    var queryParams = {};
    var values = {};

    if (_.size(selectedCustomFields) > 0) {
      var values = {};

      props.customFields.forEach(customField => {
        const fieldSelected = selectedCustomFields.find(field => field.id === customField.id);

        if (fieldSelected && fieldSelected.options) {
          values[customField.name] = fieldSelected.options.map(option => option.value);
        }
      });

    }
    this.setState({
      searchedQuery: query
    });
    var entity = entityType === "contactLists" ? "Contact Lists" : _.capitalize(entityType);

    if (entityType === "assets") {
      if (tags || values) {
        this.props.trackAdoptionMetricsForContentSearchEvent("Global Search", query, entity, tags, values);
      }
    }

    else {
      this.props.trackAdoptionMetricsForContentSearchEvent("Global Search", query, entity, [], {});
    }



    this.setState({
      filter: entityType,
    });

    if (query != "" && typeof query !== "undefined") {
      queryParams["query"] = query;
    }

    if (tags.length > 0) {
      tagsValue = tags.join(",");
      queryParams["tags"] = tagsValue;
    }

    var filter = {
      tags: tagsValue,
    };

    if (selectedCustomFields.length > 0) {
      var customFields = selectedCustomFields.map((field) => {
        var options = field.options.map((option) => {
          return option.id;
        });

        return {
          id: field.id,
          values: options,
        };
      });

      filter.customFields = customFields;
    }

    this.invalidateSearch();

    if (
      !_.isEmpty(queryParams) ||
      (props.entityType == "assets" && selectedCustomFields.length > 0)
    ) {
      this.props.search(entityType, query, true, filter, 0, 24, true);
      if (
        (query != "" && typeof query !== "undefined") ||
        (props.entityType == "assets" && selectedCustomFields.length > 0)
      ) {
        this.props.fetchTags(this.state.query, filter);
      }
    }

    if (this.state.query != null) {
      this.props.recordSearchQuery({
        query: query,
        entityType: entityType,
        tags: tags,
        customFields: filter.customFields,
      });
    }
  }

  convertFieldsFilterToQueryParams(fields) {
    if (!fields || fields.length == 0) {
      return null;
    }

    var query = fields
      .map((field) => {
        var optionsQuery = field.options
          .map((o) => {
            return o.index;
          })
          .join("|");

        return field.index + "|" + optionsQuery;
      })
      .join(",");

    return query;
  }

  convertQueryParamsToFieldsFilter(query) {
    if (!query || query.trim() == "") {
      return [];
    }

    var fieldQueries = query.split(",");
    var fieldFilters = fieldQueries.map((q) => {
      var optionQueries = q.split("|");
      var idx = optionQueries[0];

      var field = this.props.customFields[idx];

      var options = [];
      for (var i = 1; i < optionQueries.length; i++) {
        options.push({
          ...field.options[optionQueries[i]],
          index: optionQueries[i],
        });
      }

      return {
        id: field.id,
        index: idx,
        options: options,
      };
    });

    return fieldFilters;
  }

  invalidateSearch() {
    this.props.invalidateAssetSearchResult();
    this.props.invalidateCollectionsSearchResult();
    this.props.invalidateStreamsSearchResult();
    this.props.invalidateContactsSearchResult();
    this.props.invalidateContactListsSearchResult();
    this.props.invalidateTags();
  }

  recordAssetClicked(asset) {
    this.props.recordSearchQuery({
      query: this.state.query,
      entityType: this.props.entityType,
      tags: this.state.selectedTags,
      customFields: this.state.selectedCustomFields,
      asset: asset,
    });
  }

  componentDidMount() {

    this.primaryBackground = _.get(
      this.props.account,
      "theme.primaryPalette.backgroundColor"
    );
    this.props.invalidateTags();

    if (_.get(this.props, "location.query.query")) {
      this.setState({
        query: _.get(this.props, "location.query.query") || ""
      })

    }

    if (!this.props.isCustomFieldsFetched && !this.props.isCustomFieldsLoading) {
      this.props.fetchCustomFields().then(() => {
        this.handleInitialSearch();
      });
    }
    else {
      this.handleInitialSearch();
    }

    var url = this.props.location.pathname;
    this.setState({
      filter: url.substr(url.lastIndexOf("/") + 1),
    });
  }

  handleInitialSearch() {
    var tags = [];
    if (this.props.location.query && this.props.location.query.tags) {
      tags = this.props.location.query.tags.split(",");
    }

    var fields = [];
    if (this.props.location.query && this.props.location.query.fields) {
      fields = this.convertQueryParamsToFieldsFilter(
        this.props.location.query.fields
      );
    }

    if (this.props.location.query) {
      this.setState(
        {
          query:_.get(this.props, 'location.query.query', ''),
          selectedTags: tags,
          selectedCustomFields: fields,
        },
        () => {
          this._performSearch(this.props);
        }
      );
    } else {
      this.invalidateSearch();
    }
  }

  loadMoreResults() {
    let totalPages = this.props.entity.totalPages;
    let currentPage = this.props.entity.currentPage;
    var selectedCustomFields = this.state.selectedCustomFields || [];

    var page = currentPage + 1;

    if (this.props.entity.searching || page >= totalPages) {
      return;
    }

    var query = this.state.query;
    var tags = this.state.selectedTags;

    var tagsValue = null;
    if (tags.length > 0) {
      tagsValue = tags.join(",");
    }

    var filter = {
      tags: tagsValue,
    };

    if (selectedCustomFields.length > 0) {
      var customFields = selectedCustomFields.map((field) => {
        var options = field.options.map((option) => {
          return option.id;
        });

        return {
          id: field.id,
          values: options,
        };
      });

      filter.customFields = customFields;
    }

    this.props.search(
      this.props.entityType,
      query,
      true,
      filter,
      page,
      24,
      true
    );
  }

  onSelectTagClicked(selectedTag) {
    var selectedTags = this.state.selectedTags;

    var index = this.state.selectedTags.findIndex((item) => {
      return item == selectedTag;
    });

    if (index == -1) {
      selectedTags = [...selectedTags, selectedTag];
    } else {
      selectedTags = this.state.selectedTags.filter(
        (tag) => tag != selectedTag
      );
    }

    this.setState(
      {
        selectedTags: selectedTags,
      },
      () => {
        this._updateSearchUrl(this.props);
      }
    );
  }

  resetTagFilters() {
    this.setState(
      {
        selectedTags: [],
      },
      () => {
        this._updateSearchUrl(this.props);
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.entityType != nextProps.entityType) {
      this._performSearch(nextProps);
    }

    if (!isEqual(this.props.location.query, nextProps.location.query)) {
      var tagsValue = _.get(nextProps, "location.query.tags", null);
      var tags = [];

      if (tagsValue && tagsValue != "") {
        tags = tagsValue.split(",").filter((tag) => {
          return tag !== "";
        });
      }

      this.setState(
        {
          query: nextProps.location.query.query || "",
          selectedTags: tags,
        },
        () => {
          this._performSearch(nextProps);
        }
      );
    }
  }

  componentWillUnmount() { }


  handleClearQuery(e) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    this.setState({
      query: ""
    })
    const entityType = this.props.entityType;
    this.props.navigate(entityType ? `/search/${entityType}` : "/search");
    this.invalidateSearch();
  }

  handleReset() {
    this.invalidateSearch();
    this.props.invalidateSeekSession();
    this.setState({
      query: "",
    });
    this.props.navigate("/search");
  }

  clearValue(){
    this.setState({
      query: ""
    })
    this.invalidateSearch()
  }

  render() {
    const seekEnabled = _.get(this.props, "account.seekEnabled");

    const { search } = this.props.location;   // "?query=hello&fields=a|1,b|2"
    const queryParams = new URLSearchParams(search);
    const query = queryParams.get("query");
    const fields = queryParams.get("fields");

    const hasQuery = _.size(query) > 0 || _.size(fields) > 0;

    return (
      <div ref={this.containerRef} className={cx(styles.content, "search_page")}>
        <Col
          sm={12}
          className={cx(
            {
              [styles.searchContainer]:
                this.props.entityType == "assets" &&
                _.size(_.get(this.props, "customFields", [])) > 0,
            },
            styles.searchBody
          )}
        >
          <Row className={styles.top}>
            <Col sm={12} className={cx(styles.column, styles.searchBar)}>
              <Col sm={9} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.titleContainer} onClick={this.handleReset.bind(this)}>
                  <h1 className={styles.pageTitle}>{this.localizedSearch.title}</h1>
                  {!seekEnabled && <p className={styles.subTitle}>{this.localizedSearch.sub_text}</p>}
                  {seekEnabled && <p className={styles.seekSearch}> { this.localizedSearch.seek_enabled.sub_text} <span className={styles.seekText}> { this.localizedKeywords.seek } </span></p>}
                </div>
              </Col>
              <Col sm={3} xsHidden className={styles.noPadding}></Col>
            </Col>

            {hasQuery && this.state.searchedQuery && (
              <div className={styles.resultBill}>
                <div className={styles.resultTitle}>
                  showing results for <span className={styles.queryName}>"{this.state.searchedQuery}"</span>
                </div>
              </div>
            )}
          { hasQuery && <SeekResponse 
                      location={this.props.location} 
                      query={this.state.query} 
                      isFetching={() => this.validateLoadingMessage()} 
                      _onQueryChange={this._onQueryChange.bind(this)} 
                      _handleSearch={this._handleSearch} 
                      clearValue={this.handleClearQuery.bind(this)}
                  />}

          </Row>

          {hasQuery && this._renderFilterGroup()}

          {this.validateLoadingMessage() &&
            _.get(this.props,"entity.currentPage",0) === -1 &&
            this._renderLoadingMessage()}


          <SeekLandingPage
            location={this.props.location}
            query={this.state.query}
            isSearchDataExists={!this.validateEmptyMessage()}
            isFetching={() => this.validateLoadingMessage()}
            _onQueryChange={this._onQueryChange.bind(this)}
            _handleSearch={this._handleSearch}
            clearValue={this.handleClearQuery.bind(this)}
            isCustomFieldsAvailable={ this.props.entityType == "assets" && _.size(_.get(this.props, "customFields", [])) > 0}
          />

          {(_.size(_.get(this.props, "entity.items", [])) > 0 ||
            _.size(_.get(this.props, "tags", [])) > 0) && (
              <Row className={styles.container}>
                <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                  <div className={styles.section}>
                     <label
                      className={cx(styles.item, styles.text)}
                    >{`${this._renderPageTitle()} (${_.get(this.props, "entity.totalRecordsCount")
                      })`}</label>
                  </div>
                </Col>

                {hasQuery && this.props.entityType == "assets" && (
                  <Col sm={12} className={styles.noPadding}>
                    {this.renderTagView()}
                  </Col>
                )}
  
                {this.props.entityType == "assets" && (
                  <AssetSearchResultContainer
                    containerRef={this.containerRef.current}
                    items={this.props.entity.items}
                    hasMore={this.props.entity.loadMore}
                    loadMore={() => this.loadMoreResults()}
                  />
                )}


                {this.props.entityType != "assets" && (
                  <SearchResultView
                    containerRef={this.containerRef.current}
                    items={this.props.entity.items}
                    hasMore={this.props.entity.loadMore}
                    loadMore={() => this.loadMoreResults()}
                  />
                )}
              </Row>
            )}

          {this.validateLoadingMessage() &&
            !this.validateEmptyMessage() &&
            this._renderLoadingMessage()}
       { hasQuery && this.validateEmptyMessage() && !this.validateLoadingMessage() && this.renderEmptyMessage()}
        </Col>

        {this.props.entityType == "assets" &&
          _.size(_.get(this.props, "customFields", [])) > 0 && (
            <Col sm={2} className={styles.fieldContainer}>
              <CustomFieldSearchViewContainer
                fields={this.props.customFields}
                value={this.state.selectedCustomFields}
                onChange={this._handleFieldsFilterChange}
              />
            </Col>
          )}
      </div>
    );
  }

  validateLoadingMessage() {
    return _.get(this.props, "entity.searching");
  }

  validateEmptyMessage() {
    return _.size(_.get(this.props, "entity.items")) == 0;
  }

  _renderPageTitle() {
    if (this.props.entityType == "assets") {
      return this.localizedKeywords.assets;
    } else if (this.props.entityType == "collections") {
      return this.localizedKeywords.collections;
    } else if (this.props.entityType == "streams") {
      return this.localizedKeywords.streams;
    } else if (this.props.entityType == "contacts") {
      return this.localizedKeywords.contacts;
    } else if (this.props.entityType == "contactLists") {
      return this.localizedKeywords.contact_lists;
    }
  }

  _renderLoadingMessage() {
    return <div className={styles.loadingMessage}>{this.localizedCommons.actions.searching}...</div>;
  }
  renderEmptyMessage() {
    return (
      <EmptyContentView searchQuery={_.get(this.props, "entity.query")}></EmptyContentView>
    )
  }
  _renderFilterGroup() {
    return (
      <ToolBar className={styles.toolbar}>
        <ToolBarGroup item={styles.item}>
          <ToolBarButtonItem
            className={cx(styles.filterHeading)}
            width="auto"
            height="auto"
          >
            <div> {this.localizedSearch.filters.title} : </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem
            className={cx(styles.filter)}
            width="auto"
            height="auto"
          >
            <div
              className={cx(styles.link, {
                [styles.active]: this.state.filter == "all",
              })}
              onClick={this.onFilterChange.bind(this, "all")}
            >
              {this.localizedSearch.filters.everything}
            </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem
            className={cx(styles.filter)}
            width="auto"
            height="auto"
          >
            <div
              className={cx(styles.link, {
                [styles.active]: this.state.filter == "assets",
              })}
              onClick={this.onFilterChange.bind(this, "assets")}
            >
              {this.localizedKeywords.assets}
            </div>
          </ToolBarButtonItem>
          {userRoleService.canAccessCollection() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "collections",
                })}
                onClick={this.onFilterChange.bind(this, "collections")}
              >
                {this.localizedKeywords.collections}
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canAccessHub() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "streams",
                })}
                onClick={this.onFilterChange.bind(this, "streams")}
              >
                {this.localizedKeywords.streams}
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canShare() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "contacts",
                })}
                onClick={this.onFilterChange.bind(this, "contacts")}
              >
                {this.localizedKeywords.contacts}
              </div>
            </ToolBarButtonItem>
          }
          {userRoleService.canShare() &&
            <ToolBarButtonItem
              className={cx(styles.filter)}
              width="auto"
              height="auto"
            >
              <div
                className={cx(styles.link, {
                  [styles.active]: this.state.filter == "contactLists",
                })}
                onClick={this.onFilterChange.bind(this, "contactLists")}
              >
                {this.localizedKeywords.contact_lists}
              </div>
            </ToolBarButtonItem>
          }
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderTagView() {
    if (!(this.props.tags && this.props.tags.length > 0)) {
      return false;
    }

    return (
      <Col md={12} className={styles.noPadding}>
        <div className={styles.tagView}>
          <div
            key={"all"}
            className={cx(styles.tag, {
              [styles.active]: !_.get(this.props, "location.query.tags"),
            })}
            onClick={this.resetTagFilters.bind(this)}
          >
            #{this.localizedSearch.asset.all_tags} ({this.props.totalItems}),
          </div>
          {this.renderTags()}
        </div>
      </Col>
    );
  }

  renderTags() {
    return _.get(this.props, "tags", []).map((tag, index) => {
      var selected =
        _.get(this.state, "selectedTags").findIndex((item) => tag.key == item) != -1;

      return (
        <div
          key={index}
          className={cx(styles.tag, { [styles.active]: selected })}
          onClick={this.onSelectTagClicked.bind(this, tag.key)}
        >
          #{tag.key}({tag.count}),
        </div>
      );
    });
  }
}

export default DetailedSearchView;